import React from 'react';
import { motion } from 'framer-motion';
import { StarRating } from './StarRating';
const results = [{
  tag: 'RPG Review Hub',
  rating: 5,
  metrics: ['+340% organic traffic', '€47,200/mo revenue']
}, {
  tag: 'FPS Comparison Engine',
  rating: 4.5,
  metrics: ['+520% rich snippet impressions', '€31,800/mo revenue']
}, {
  tag: 'Indie Games Digest',
  rating: 5,
  metrics: ['+280% affiliate conversions', '€22,600/mo revenue']
}, {
  tag: 'Racing Sim Rankings',
  rating: 4,
  metrics: ['+410% indexed pages', '€38,900/mo revenue']
}, {
  tag: 'Strategy Games Atlas',
  rating: 5,
  metrics: ['+190% domain authority', '€55,100/mo revenue']
}, {
  tag: 'Retro Gaming Vault',
  rating: 4.5,
  metrics: ['+630% click-through rate', '€19,400/mo revenue']
}];
export function ReviewGrid() {
  return <section id="results" className="py-32 bg-gameu-card border-y border-gameu-elevated" data-id="element-118">
      <div className="max-w-7xl mx-auto px-6" data-id="element-119">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-16 flex flex-col md:flex-row md:items-end justify-between gap-6" data-id="element-120">
          <div data-id="element-121">
            <h2 className="font-serif text-5xl md:text-6xl text-gameu-text mb-6" data-id="element-122">
              The Proof Is in the Rankings
            </h2>
            <p className="text-gameu-muted text-lg max-w-2xl" data-id="element-123">
              Real metrics from gaming properties we've re-architected.
            </p>
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-124">
          {results.map((result, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1,
          duration: 0.4
        }} className="bg-gameu-base border border-gameu-elevated p-6 flex flex-col" data-id="element-125">
              <div className="flex justify-between items-start mb-8" data-id="element-126">
                <span className="text-xs font-medium tracking-wider uppercase text-gameu-muted bg-gameu-elevated px-3 py-1" data-id="element-127">
                  {result.tag}
                </span>
              </div>

              <div className="mb-8" data-id="element-128">
                <StarRating rating={result.rating} starSize={24} data-id="element-129" />
              </div>

              <div className="mt-auto space-y-3 pt-6 border-t border-gameu-elevated" data-id="element-130">
                {result.metrics.map((metric, mIdx) => <div key={mIdx} className="flex items-center gap-3" data-id="element-131">
                    <div className="w-1.5 h-1.5 rounded-full bg-gameu-accent" data-id="element-132" />
                    <span className="text-gameu-text text-sm font-medium" data-id="element-133">
                      {metric}
                    </span>
                  </div>)}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}